/**
 * O selo "assinatura" de uma sessão do NanoGPT (D45): o modelo dela está
 * incluído na assinatura, e o custo ao lado é o equivalente de tabela. Só com
 * `true` — ausente é "não sei", e `false` é o modelo que gasta crédito.
 *
 * Um componente só para as três telas que o mostram — a linha do Uso, o
 * cabeçalho da conversa e a lista —, como o `SeloForaDeCasa`: a frase e a cor
 * não podem divergir entre elas na primeira revisão de texto.
 */
export function SeloAssinatura({
  assinatura,
  className,
}: {
  assinatura: boolean | undefined;
  className?: string;
}): React.JSX.Element | null {
  if (assinatura !== true) return null;
  return (
    <span
      data-testid="selo-assinatura"
      title="Modelo incluído na assinatura do NanoGPT: o custo ao lado é o equivalente em preço de tabela, não dinheiro."
      className={
        'shrink-0 rounded bg-emerald-500/10 px-1 py-0.5 text-[10px] uppercase tracking-wide text-emerald-300 ' +
        (className ?? '')
      }
    >
      assinatura
    </span>
  );
}
